import LabelProvider from "core/components/label/LabelProvider";
import { Messages } from "common/Labels/Messages";
import { filters } from "common/Labels/Refine";

export default LabelProvider.create({

	PostDate: {
		k: "topic.createdOn",
		v: "Post Date"
    },
    PostTitle:{
        k:"topic.name",
        v:"Post Title"
    },
    OrganizationEmpty:{
        k: "organization.missing.title",
        v: "No Organization Selected"
    },
    DescriptionEmpty:{
        k: "organization.missing.description",
        v: "Please select an organization to see the user list."
    },
    ...Messages,
    ...filters,
    FlaggedTimes:{
        k: "flagged.topic.template",
        v: "Flagged ${flags} Times",
        argNames:['flags']
    },
    CreatedOn: {
        k:"topic.createdOn",
        v: "Created On"
    },
    CategoryName:{
        k: "topic.category.template",
        v: "In ${categoryName}",
        argNames:['categoryName']
    },
    MarkAsSafe: {
        k: "topic.flagged.approve",
        v: "Mark as Safe"
    },
    Delete: {
        k:"topic.flagged.delete",
        v: "Delete"
    }
});



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/FlaggedTopicList.labels.ts